<template>
  <div class="ticket-portal-profile">
    <loading-placeholder v-if="isLoading" :lines="10" />
    <template v-else>
      <ticket-portal-header
        :ticket-portal-name="data.ticketPortalName" 
        :customer="data.customer" 
        :logo-url="data.logoUrl"
      />
      <div class="title scripty">Your Profile</div>
      <div class="profile">
        <el-form label-position="top">
          <el-form-item label="Full Name" prop="name">
            <el-input ref="nameRef" v-model="data.name" placeholder="Enter your full name" maxlength="100" required />
          </el-form-item>
          <el-form-item label="Time Zone" prop="timezone">
            <single-select v-model="data.timezone" placeholder="Choose a time zone...">
              <el-option v-for="tz in data.listTimeZones" :key="tz.name" :value="tz.name" :label="tz.value" />
            </single-select>
          </el-form-item>
          <dd-button 
            :is-loading="isSubmitting"
            color="dark-teal" 
            @click="updateProfile()">Update profile</dd-button>
        </el-form>
      </div>
      <ticket-portal-footer />
    </template>   
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */
import TicketPortalHeader from './components/ticket-portal-header.vue'
import TicketPortalFooter from './components/ticket-portal-footer.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */
import TicketPortalAPI from '@/api/modules/ticket-portal.api'
import { ITicketPortalOutputProfile } from '@/api/types/response.types'
import { ITicketPortalInputUpdateProfile } from '@/api/types/request.types'

export default defineComponent({
  name: 'TicketPortalProfile',

  components: { TicketPortalHeader, TicketPortalFooter },

  data() {
    return {
      RouteAssistant,
      isLoading: true,
      isSubmitting: false,
      data: {} as ITicketPortalOutputProfile,
    }
  },

  head(): any {
    return {
      title: this.data.ticketPortalName,
    }
  },

  computed: {
    mailboxID(): number {
      return Number(this.$route.params.mailboxId)
    },
  },

  async created() {
    this.isLoading = true
    await this.getProfile()
    this.isLoading = false
  },

  methods: {
    async getProfile() {
      try {
        this.data = await TicketPortalAPI.get_Profile(this.mailboxID)
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async updateProfile() {
      try {
        this.isSubmitting = true
        const data = {
          name: this.data.name,
          timezone: this.data.timezone,
        } as ITicketPortalInputUpdateProfile
        const response = await TicketPortalAPI.put_Profile(this.mailboxID, data)
        this.$messaging.showSuccess(response.message)
      } catch (error) {
        this.$error.emit(error)
      } finally {
        await this.getProfile()
        this.isSubmitting = false
      }
    },
  },
})
</script>

<style lang="scss">
.ticket-portal-profile {
  $side-margin-px: 30px;

  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--color-background-primary);

  .loading-placeholder {
    margin-top: 20px;
    width: 90%;
  }

  .title {
    margin: 20px 0;
    font-size: 36px;
    color: var(--color-text-secondary);
  }

  .profile {
    width: 800px;
    padding: $side-margin-px;
    background-color: var(--color-background-header);
    border-radius: 8px;
    border: solid 1px $color--gray-30;

    @include media-breakpoint-up(md) {
      @include standard-box-shadow;
    }

    @include media-breakpoint-down(sm) {
      border-radius: 0px;
      border-left: none;
      border-right: none;
      width: 100%;
    }

    .dd-button {
      margin-left: auto;
    }
  }
}
</style>
